export const API_ROUTES = {
  // IAM
  SAML_AUTH: '/saml-token',
  REFRESH_TOKEN: '/refresh-token',

  // CRM
  CONTRACTS: '/contracts',

  // Edition
  INVOICE: '/invoices',

  // PPA
  SEND: '/send',
  ALERTS: '/alerts',
  EDITED_INVOICES: '/edited-invoices',
  CONTRACTS_INVOICES: '/contracts-invoices',
  SUMMARY_INVOICES: '/invoices/summary',

  // Settings
  SETTINGS: '/parameters',

  // Download
  DOWNLOAD: '/download',
};

export const API = {
  IAM: '/iam',
  PPA: '/ppa',
  EDITION: '/edition',
};
